/* Footer link columns: collapsed on phones, always open on desktop.

   The footer is 1,758px on a 375px screen — 2.2 screens of the 11.4-screen
   page, almost all of it 26 link rows in four stacked columns. Collapsing them
   behind their own headings gives that back without removing a single link
   (they stay in the DOM, so nothing changes for crawlers).

   Progressive enhancement: the markup ships with `open` on every <details>, so
   with JavaScript off the footer behaves exactly as it does today — fully
   expanded. This only ever CLOSES things, and only below the breakpoint. */
(function () {
  'use strict';

  var mql = window.matchMedia('(max-width: 900px)');

  function apply() {
    var discs = document.querySelectorAll('.pc-footer__disc');
    if (!discs.length) return;

    Array.prototype.forEach.call(discs, function (d) {
      if (mql.matches) {
        /* Don't fight the visitor: once they have opened a column themselves,
           leave it alone for the rest of the page view. */
        if (d.dataset.pcTouched === '1') return;
        d.open = false;
      } else {
        d.open = true;
      }
    });
  }

  function init() {
    var discs = document.querySelectorAll('.pc-footer__disc');
    if (!discs.length) return;

    Array.prototype.forEach.call(discs, function (d) {
      d.addEventListener('toggle', function () {
        if (mql.matches) d.dataset.pcTouched = '1';
      });
    });

    apply();
    if (mql.addEventListener) mql.addEventListener('change', apply);
    else if (mql.addListener) mql.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
